import React, { useContext, useEffect, useState } from "react";

import { AppContext } from "App";
import { scrollToTop } from "utils/common";

import RequirementsCheckerQuestionnaire from "./RequirementsCheckerQuestionnaire";
import RequirementsCheckerResult from "./RequirementsCheckerResult";
import RequirementsCheckerStarterScreen from "./RequirementsCheckerStarterScreen";

export enum ViewState {
    // eslint-disable-next-line no-unused-vars
    Starter = "starter",
    // eslint-disable-next-line no-unused-vars
    Questionnaire = "questionnaire",
    // eslint-disable-next-line no-unused-vars
    Result = "result",
}
export interface Answer {
    question: string;
    answer: string | string[];
}

export type AnswersArr = Answer[];

export const RESULT_TYPES = {
    NOT_RELEVANT: "MTD-not-relevant" as const,
    NOT_REGISTERED: "MTD-not-registered" as const,
    NOT_NEED: "MTD-not-need" as const,
    TOO_EARLY: "MTD-to-early" as const,
    MTD_2028: "MTD-2028" as const,
    MTD_2027: "MTD-2027" as const,
    MTD_2026: "MTD-2026" as const,
};

interface RequirementsCheckerProps {
    resetTrigger: boolean;
    setIsStartingPage: React.Dispatch<React.SetStateAction<boolean>>;
}

const RequirementsChecker: React.FC<RequirementsCheckerProps> = ({ resetTrigger, setIsStartingPage }) => {
    const { maxWidth, setShowFooter, isMobile } = useContext(AppContext);

    const [view, setView] = useState<ViewState>(ViewState.Starter);
    const [resultType, setResultType] = useState<string>("");
    const [answers, setAnswers] = useState<AnswersArr>([]);
    const [current, setCurrent] = useState<number>(0);
    const [selected, setSelected] = useState<string[]>([]);

    const handleComplete = (type: string) => {
        setResultType(type);
        setView(ViewState.Result);
    };

    const handleBack = () => {
        if (current > 0) {
            setAnswers(prev => prev.slice(0, -1));
            setSelected([]);
            if (view === "result") {
                setView(ViewState.Questionnaire);
            } else {
                setCurrent(curr => curr - 1);
            }
        } else {
            setSelected([]);
            setAnswers([]);
            setView(ViewState.Starter);
        }
    };

    useEffect(() => {
        setShowFooter(!isMobile);
        return () => {
            setShowFooter(true);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMobile]);

    useEffect(() => {
        if (resetTrigger) {
            setSelected([]);
            setAnswers([]);
            setCurrent(0);
            setView(ViewState.Starter);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetTrigger]);

    useEffect(() => {
        setIsStartingPage(view === "starter");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [view]);

    useEffect(() => {
        scrollToTop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [current, view]);

    return (
        <div className="requirements-checker" style={{ maxWidth: maxWidth }}>
            <div className="requirements-checker__wrapper">
                {view === "starter" && <RequirementsCheckerStarterScreen setView={setView}/>}
                {view === "questionnaire" && <RequirementsCheckerQuestionnaire
                    onComplete={handleComplete}
                    current={current}
                    selected={selected}
                    answers={answers}
                    setAnswers={setAnswers}
                    setCurrent={setCurrent}
                    setSelected={setSelected}
                    handleBack={handleBack}
                />}
                {view === "result" && <RequirementsCheckerResult resultType={resultType} answers={answers} handleBack={handleBack}/>}
            </div>
        </div>
    );
};

export default RequirementsChecker;
